import useTypedTranslation, {
  type TFunctionType,
} from "@/core/hooks/use-typed-translation";

/**
 * Traductions des écrans merchant (clés `merchant.*`).
 *
 * Les clés vivent dans les fragments `features/merchant/i18n/*.json` et
 * seront fusionnées dans `src/locales/*.json` par le coordinateur : tant
 * que la fusion n'est pas faite, `TFunctionType` (dérivé de fr.json) ne
 * les connaît pas encore, d'où le cast.
 */
export const useMerchantTranslation = () => {
  const { t } = useTypedTranslation();
  return { t: (key: string) => t(key as TFunctionType) };
};
